import styled, { css } from 'styled-components';
import { themeContract } from './ProductPanel.theme.contract';
var Wrapper = styled.div.withConfig({
  displayName: "ProductPanelstyles__Wrapper",
  componentId: "sc-1keik90-0"
})(["min-width:180px;width:100%;font-family:", ";font-weight:", ";& + &{margin-top:10px;}"], function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.weight.regular;
});
var Container = styled.div.withConfig({
  displayName: "ProductPanelstyles__Container",
  componentId: "sc-1keik90-1"
})(["display:flex;flex-wrap:", ";position:relative;", ""], function (props) {
  return props.showWishlistButton ? 'nowrap' : 'wrap';
}, function (props) {
  return css(["@media screen and (min-width:", "){flex-wrap:nowrap;}", " ", ""], props.theme.size.breakpoint['min-width'].sm, props.showBorder && css(["border-top:1px solid ", ";border-bottom:1px solid ", ";margin-bottom:-1px;padding:15px 10px;"], props.theme.color.monochrome.light, props.theme.color.monochrome.light), props.isLoading && css(["display:block;border-top:1px solid ", ";border-bottom:1px solid ", ";margin-bottom:-1px;"], props.theme.color.monochrome.light, props.theme.color.monochrome.light));
});
var DetailsContainer = styled.div.withConfig({
  displayName: "ProductPanelstyles__DetailsContainer",
  componentId: "sc-1keik90-2"
})(["display:flex;flex-direction:row;width:100%;"]);
var Thumbnail = styled.div.withConfig({
  displayName: "ProductPanelstyles__Thumbnail",
  componentId: "sc-1keik90-3"
})(["display:flex;flex-direction:column;margin-right:", ";position:relative;flex-shrink:0;img{margin-top:5px;}"], function (props) {
  return props.condensed ? '15px' : '20px';
});
var Details = styled.div.withConfig({
  displayName: "ProductPanelstyles__Details",
  componentId: "sc-1keik90-4"
})(["width:100%;", ";"], function (props) {
  return css(["@media screen and (min-width:", "){width:100%;}"], props.theme.size.breakpoint['min-width'].sm);
});
var Name = styled.a.withConfig({
  displayName: "ProductPanelstyles__Name",
  componentId: "sc-1keik90-5"
})(["font-size:", ";font-weight:", ";line-height:1.5;@media screen and (max-width:", "){line-height:normal;}"], function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return props.theme.font.weight.bold;
}, function (props) {
  return props.theme.size.breakpoint['max-width'].xs;
});
var PartNumber = styled.div.withConfig({
  displayName: "ProductPanelstyles__PartNumber",
  componentId: "sc-1keik90-6"
})(["margin-top:", ";color:", ";font-size:", ";", ""], function (props) {
  return props.condensed ? '3px' : '5px';
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.font.size.base;
}, function (props) {
  return css(["@media screen and (min-width:", "){width:100%;}"], props.theme.size.breakpoint['min-width'].sm);
});
var Ratings = styled.div.withConfig({
  displayName: "ProductPanelstyles__Ratings",
  componentId: "sc-1keik90-7"
})(["margin:5px 0 5px 0;"]);
var Quantity = styled.div.withConfig({
  displayName: "ProductPanelstyles__Quantity",
  componentId: "sc-1keik90-8"
})(["margin-top:5px;flex:1;font-size:", ";"], function (props) {
  return props.theme.font.size.base;
});
var Custom = styled.div.withConfig({
  displayName: "ProductPanelstyles__Custom",
  componentId: "sc-1keik90-9"
})(["margin-top:5px;"]);
var Prices = styled.div.withConfig({
  displayName: "ProductPanelstyles__Prices",
  componentId: "sc-1keik90-10"
})(["display:block;line-height:normal;text-align:left;width:100%;", " ", ""], function (props) {
  return css(["@media screen and (min-width:", "){width:180px;margin-left:0px;text-align:right;}"], props.theme.size.breakpoint['min-width'].sm);
}, function (props) {
  return props.showThumbnail && css(["margin-left:90px;"]);
});
var Price = styled.div.withConfig({
  displayName: "ProductPanelstyles__Price",
  componentId: "sc-1keik90-11"
})(["", " ", ";"], function (props) {
  return props.flashText && css(["color:", ";"], props.theme.color.palette[themeContract[props.theme.channel].price.color]);
}, function (props) {
  return props.wasPrice && css(["color:", ";text-decoration:line-through;@media screen and (min-width:", "){top:auto;}"], props.theme.color.monochrome.base, props.theme.size.breakpoint['min-width'].sm);
});
var InlinePrice = styled.div.withConfig({
  displayName: "ProductPanelstyles__InlinePrice",
  componentId: "sc-1keik90-12"
})(["margin-top:5px;text-align:right;flex:1;font-weight:", ";"], function (props) {
  return props.theme.font.weight.bold;
});
var LastRow = styled.div.withConfig({
  displayName: "ProductPanelstyles__LastRow",
  componentId: "sc-1keik90-13"
})(["display:flex;margin-top:6px;"]);
var MoreDetails = styled.div.withConfig({
  displayName: "ProductPanelstyles__MoreDetails",
  componentId: "sc-1keik90-14"
})(["margin-top:5px;", ";"], function (props) {
  return css(["@media screen and (max-width:", "){right:0px;bottom:10px;}"], props.theme.size.breakpoint['max-width'].xs);
});
export var AddToWishlistButtonContainer = styled.div.withConfig({
  displayName: "ProductPanelstyles__AddToWishlistButtonContainer",
  componentId: "sc-1keik90-15"
})(["margin-left:20px;display:flex;flex-shrink:0;align-items:center;align-self:center;justify-content:center;width:44px;height:44px;"]);
export { Wrapper, DetailsContainer, Name, Container, Thumbnail, Details, InlinePrice, Ratings, PartNumber, Quantity, Custom, Prices, Price, MoreDetails, LastRow };